module.exports = __webpack_public_path__ + "media/yujing.38d3b136.mp3";